import React from 'react'

export default ({element}) => <>{element}</>
